<template>
	<div>
		<div class="xqlist">
			<figure style="width:100%; text-align:center;padding-top:50px;" v-if="list.length==0">
			   <img src="@/assets/kong.png" alt="" srcset="" />
			   <figcaption>暂无数据</figcaption>
			</figure>
			   <div class="liebiao1" v-for="(item, index) in list" :key="item.d_id || ('invite-' + index)">
					<div class="title" @click="datails(item.d_id)">
						<h4 class="titleh4">{{item.demand.name}}</h4>
						<span v-if="item.demand.status==1">报价中</span>
						<span v-if="item.demand.status==2 && item.demand.is_off==0" style="color:#4DC800;">已结束</span>
						<span v-if="item.demand.status==2 && item.demand.is_off==1" style="color:#666666;">平台下架</span>
					</div>
					<div class="titleTiem" @click="datails(item.d_id)">
						<img src="@/assets/tiem.png" alt="" srcset="" />
						<span>邀标时间：{{item.create_time}}</span>
					</div>
					<div class="hylist">
						<div  v-for="(i) in item.demand.industries" :key="i">{{i}}</div>
					</div>
					<div class="hybox" @click="datails(item.d_id)">
						<span>{{ item.demand.description}}</span>
					</div>
					<div class="hytiem" v-if="item.demand.status==1 && item.status==0" @click="datails(item.d_id)">
						<span>报价剩余时间：</span>
						<CountDown :endTime="item.expire_time * 1000"></CountDown>
					</div>
					<div class="hyfooter" v-if="item.demand.status==1">
                        <div class="hyfooter1" v-if="item.status==0" @click.stop="jujue(item.di_id)">不参与</div>
						<div class="hyfooter2" v-if="item.status==0" @click.stop="baojia(item.d_id)">立即报价</div>
						<div class="hyfooter3" v-if="item.status==1" :class="{'yaonioa':item.status==1}">已参与</div>
						<div class="hyfooter4" v-if="item.status==-1" :class="{'yaonioa':item.status==-1}">已拒绝</div>
						<div class="hyfooter4" v-if="item.status==-2" :class="{'yaonioa':item.status==-1}">已失效</div>
					</div>
					<div class="hyfooter" v-if="item.demand.status==2">
						<div class="hyfooter4" v-if="item.status==0" :class="{'yaonioa':item.status==1}">未参与</div>
						<div class="hyfooter3" v-if="item.status==1" :class="{'yaonioa':item.status==1}">已参与</div>
						<div class="hyfooter4" v-if="item.status==-1" :class="{'yaonioa':item.status==-1}">已拒绝</div>
						<div class="hyfooter4" v-if="item.status==-2" :class="{'yaonioa':item.status==-2}">已失效</div>
					</div>
			   </div>
		</div>
		
		<el-dialog
		  title="报价填写"
		  :visible.sync="dialogVisible"
		  :close-on-click-modal="false"
		  width="810px">
		  <div>
			  <div class="canshu" style="text-align:left;font-size: 12px;color: rgb(255, 0, 0);margin-bottom:10px;padding-left: 120px;">
			  	 需方付款后您需要在预计周期的一半时间内上传承认图，否则会导致订单退款，生产图同理
			  </div>
			 <el-form :model="valiFormData" :rules="rules" ref="valiFormData" label-width="120px" class="demo-ruleForm">
			   <el-form-item label="报价金额" prop="price">
			     <el-input v-model="valiFormData.price" placeholder="请根据要求合理报价">
					  <template slot="append">元</template>
				 </el-input>
				<!-- invite_status -->
			   </el-form-item>
			   <el-form-item label="预计完成时间" prop="period">
			      <el-input v-model="valiFormData.period" placeholder="请根据要求合理预估时间，便于需求方评估">
					   <template slot="append">小时</template>
				  </el-input>
			   </el-form-item>
			   </el-form-item>
			   <el-form-item label="附件上传" v-if="quote_file_config==1">
			 	   <el-upload
			 	     class="upload-demo"
			 	     :action="uploadActionUrl"
			 	     :on-preview="handlePreview"
			 	     :on-remove="handleRemove"
			 	     :on-success="handleUploadSuccess"
			 	     :before-remove="beforeRemove"
			 	     :multiple='false'
			 	     :limit="4"
			 	     :on-exceed="handleExceed"
			 	     :file-list="fileList">
			 		 <div>
			 			<el-button size="small" type="primary" icon="el-icon-upload">点击上传</el-button>
			 			<span style="margin-left:10px;font-size: 12px;color: #FF0000;">
			 				 单个文件最大支持10M，最多不超过四个文件，仅支持png，jpg，pdf文件类型
			 			</span>
			 		 </div>
			 	   </el-upload>
			   </el-form-item>
			 </el-form>
		  </div>
		  <div style="margin-top:30px;text-align: center;">
			<p style="color: #FF0000;margin-bottom:10px;font-size:12px;">提示：请如实填写报价信息，提交后不可修改</p>
			<span slot="footer" class="dialog-footer">
			  <el-button @click="dialogVisible = false">取 消</el-button>
			  <el-button type="primary" @click="submitForm('valiFormData')">确 定</el-button>
			</span>   
		  </div>
		</el-dialog>
		
	</div>
</template>

<script>
	import {
		DemandIndex,
		banner,
		personal,
		QuoteAdd,
		BaseGetConfig,
		rejectDi_id
	} from "@/api/api.js"
	import CountDown from '@/common/CountDown.vue'
	import config from '@/config/index'
	export default {
	  name: 'HelloWorld',
	  components:{
	  		CountDown,
	  },
	  data() {
	    return {
			
		  baseURL:config.baseURL,
		  dialogVisible:false,
		  valiFormData: {
				price: '',
				period: '',
				file:[]
		  },
		  quote_file_config:"",
		  
		  rules: {
				price: [
				  { required: true, message: '报价金额不能为空', trigger: 'blur' },
				  { format: 'number', message: '报价金额只能是数字' }
				],
				period: [
				  { required: true, message: '完成周期不能为空', trigger: 'change' },
				]
		  },
		  fileList:[],
		  d_id:""
	    }
	  },
	  props:{
		  list:{}
	  },
	  watch:{
		  dialogVisible:{
			  handler(newValue,oldValue){
				  if(newValue==false){
						this.valiFormData.price=""
						this.valiFormData.period=""
						this.valiFormData.file=[]
						this.fileList=[]
					  }
				  },
				 deep:true
			}
	  },
	  computed: {
	  		isPersonalCenterActive() {
	  		  const p = this.$route && this.$route.path ? this.$route.path : ''
	  		  return /^\/demandHome\/(demandinvoiceList|demandUserInfo|demandPromotion)(\/|$)/.test(p)
	  		},
			// 完整上传地址 = baseURL + 接口路径（若后端路径不同请改下方 '/Upload/upload'）
			uploadActionUrl() {
				const base = this.baseURL || ''
				const path = (base.endsWith('/') ? '' : '/') + 'Upload/upload'
				return base + path
			},
			type(){
				return this.$route.query.type || ''
			}
	  },
	  created() {
	  	this.getBaseGetConfig()
	  },
	  methods: {
		getBaseGetConfig(){
			BaseGetConfig({
				key:"quote_file_config"
			}).then(res=>{
				this.quote_file_config=res.data.data.quote_file_config
			})
		},
		datails(e){
			const targetPath = '/serviceHome/invitedList/invitedDatails?d_id='+e
			if (this.$route.path !== targetPath) {
				this.$router.push(targetPath)
			}
		},
		handleExceed(files, fileList) {
				   this.$message.warning(`最多上传 4 个文件，当前已选 ${fileList.length} 个，本次选择了 ${files.length} 个，请勿超出限制`)
		},
		getUploadUrlFromResponse(response) {
		  if (!response) return ''
		  if (typeof response === 'string') return response
		  const level1 = response.data || {}
		  const level2 = level1.data || {}
		  const candidate =
			level2.url ||
			level2.file ||
			level1.url ||
			level1.file ||
			response.url ||
			response.file ||
			''
		  if (Array.isArray(candidate)) return candidate[0] || ''
		  if (typeof candidate === 'string') return candidate
		  if (Array.isArray(level1)) return level1[0] || ''
		  if (typeof level1 === 'string') return level1
		  return ''
		},
		handleUploadSuccess(response, file, fileList) {
		  this.fileList = fileList
		  const uploadedUrl = this.getUploadUrlFromResponse(response) || file.url || ''
		  if (uploadedUrl) {
			const exists = this.valiFormData.file.includes(uploadedUrl)
			if (!exists) this.valiFormData.file.push(uploadedUrl)
		  }
		},
		beforeRemove(file, fileList) {
		   this.fileList = fileList;
		   console.log(this.fileList)
		},
		handleRemove(file, fileList) {
		  this.fileList = fileList
		  const removedUrl = this.getUploadUrlFromResponse(file.response) || file.url || ''
		  if (!removedUrl) return
		  this.valiFormData.file = this.valiFormData.file.filter((url) => url !== removedUrl)
		},
		getBaseGetConfig(){
			BaseGetConfig({
				key:"quote_file_config"
			}).then(res=>{
				this.quote_file_config=res.data.data.quote_file_config
			})
		},
		handlePreview(file) {
		  console.log(file)
		},
		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
			  if (valid) {
				this.gettijiao()
			  } else {
				return false;
			  }
			});
		},
		gettijiao(){
			console.log("222")
			if(this.fileList.length>0){
				this.fileList.forEach(res=>{
					this.valiFormData.file.push(res.response.data)
				})
			}
			QuoteAdd({
				...this.valiFormData,
				d_id:this.d_id,
			}).then(res=>{
				console.log("333")
				if(res.data.status==200){
					this.$message.success('提交成功！');
					this.dialogVisible=false
					this.$emit("gengxin",this.dialogVisible)
				}else{
					// this.$message.error(res.data.msg);
					this.$emit("gengxin",this.dialogVisible)
				}
			})
		},
		baojia(d_id){
			this.dialogVisible=true
			this.d_id=d_id
		},
		jujue(d_id){
			let that=this
			this.$confirm(`您确定要拒绝邀标吗?`, '提示', {
			  confirmButtonText: '确定',
			  cancelButtonText: '取消',
			  type: 'warning'
			}).then(() => {
				rejectDi_id(d_id,{
				}).then(res=>{
					if(res.data.status==200){
						that.$message.success('提交成功！');
						that.$emit('gengxin',"0")
					}
				})
			}).catch(() => {
			 
			})
		}
	  },
	}
</script>

<style scoped>
	.xqlist{
			width:1200px;
			margin: 0 auto;
			display:flex;
	/* 		justify-content:space-between; */
			flex-wrap:wrap;
		}
		.xqlist>div:nth-child(3n){
			margin-right:0px;
		}
		.liebiao1{
			width:384px;
			height:247px;
			background: #FFFFFF;
			box-shadow: 0px 4px 4px 0px rgba(0,0,0,0.05);
			border-radius: 12px;
			margin-bottom:24px;
			margin-right:24px;
			padding:12px;
			box-sizing: border-box;
			cursor:pointer;
			transition: all 0.3s;
			position: relative;
		}
		.liebiao1:hover{
			transform: scale(1.03);
		}
		.title{
			width:100%;
			display:flex;
			justify-content:space-between;
		}
		.titleh4{
			width:260px;
			overflow: hidden; 
			text-overflow: ellipsis;
			white-space: nowrap;
		}
		.title span{
			color:#1E3A8A;
		}
		.titleTiem{
			width:100%;
			display:flex;
			align-items: center;
		}
		.titleTiem img{
			width:12px;
			height:12px;
			margin-right:5px;
		}
		.titleTiem span{
			font-weight: 400;
			font-size: 12px;
			color: #999999;
		}
		.hylist{
			width:100%;
			overflow: hidden;
			overflow-x: scroll;
			display:flex;
			white-space:nowrap;
		}
		.hylist::-webkit-scrollbar{
			display:none;
		}
		.hylist div{
	        padding:3px 5px;
			box-sizing: border-box;
			background: rgba(66,151,255,0.15);
			border-radius: 4px;
			float: left;
			font-weight: 500;
			font-size: 12px;
			color: #4297FF;
			margin-right:6px;
			margin-top:6px;
		}
		.hybox{
			width:100%;
			height:60px;
			margin-top:5px;
			font-weight: 400;
			font-size: 14px;
			color: #666666;
			display: -webkit-box;
			-webkit-line-clamp: 3;
			-webkit-box-orient: vertical;
			overflow: hidden;
			text-overflow: ellipsis;
		}
		.hytiem{
			width:100%;
			display:flex;
			justify-content:space-between;
			align-items: center;
			margin-top:12px;
			background: #FFF8E5;
			border-radius: 4px 4px 4px 4px;
			padding:5px 8px;
			box-sizing: border-box;
		}
		.hytiem span{
			font-weight: 500;
			font-size: 14px;
			color: #FF5900;
		}
		.hyfooter{
			width: 360px;
			display: flex;
			align-items: center;
			justify-content: space-between;
			margin-top: 12px;
			position: absolute;
			bottom: 10px;
			left: 12px;
		}
		.hyfooter1{
			width: 174px;
			height: 32px;
			font-size: 14px;
			border-radius: 8px;
			background: rgba(30,58,138,0.15);
			color:#1E3A8A;
			display:flex;
			align-items:center;
			justify-content: center;
		}
		.hyfooter2{
			width: 174px;
			height: 32px;
			border-radius: 8px;
			font-size: 14px;
			background: #1E3A8A;
			color: #FFFFFF;
			display:flex;
			align-items:center;
			justify-content: center;
		}
		.hyfooter3{
			width:100%;
			height: 32px;
			font-size: 14px;
			border-radius: 8px;
			background: rgba(30,58,138,0.15);
			color:#1E3A8A;
			display:flex;
			align-items:center;
			justify-content: center;
		}
		.hyfooter4{
			width:100%;
			height: 32px;
			font-size: 14px;
			border-radius: 8px;
			background: #CCCCCC;
			color:#666666;
			display:flex;
			align-items:center;
			justify-content: center;
		}
		.yaonioa{
			width:100% !important;
		}
</style>